var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpPcInclusionIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.77778L4.11111 1L9 2.77778M1 2.77778V5L5.88889 6.77778L9 5V2.77778M1 2.77778L5.88889 4.55556L9 2.77778",
    stroke: "#EB662B",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5V7.22222L5.88889 9L9 7.22222V5",
    stroke: "#EB662B",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpPcInclusionIconYellow);
export default __webpack_public_path__ + "static/media/cp-pc-inclusion-icon-yellow.85c341c4522682aa5d46298121fa38b0.svg";
export { ForwardRef as ReactComponent };